// src/components/eventos/components/diretor/EventosRecentes.js
import React, { useState, useMemo } from 'react';

const formatarData = (dataString) => {
    if (!dataString) return 'Data não informada';
    try {
        const [ano, mes, dia] = dataString.split('T')[0].split('-');
        return `${dia}/${mes}/${ano}`;
    } catch { return 'Data inválida'; }
};

const SmCheckIcon = () => (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

const ChevronDown = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
    </svg>
);

const STATUS = {
    concluido:    { label: 'Concluído',    color: '#2CCB90', bg: 'rgba(44,203,144,0.1)',  border: 'rgba(44,203,144,0.2)' },
    em_andamento: { label: 'Em Andamento', color: '#2563eb', bg: 'rgba(37,99,235,0.08)', border: 'rgba(37,99,235,0.2)' },
    agendado:     { label: 'Agendado',     color: '#ea580c', bg: 'rgba(234,88,12,0.08)',  border: 'rgba(234,88,12,0.18)' },
};

const EventoCard = ({ evento }) => {
    const [expanded, setExpanded] = useState(false);
    const st = STATUS[evento.status] || STATUS.agendado;

    const stats = useMemo(() => {
        const tarefas = evento.tarefas || [];
        const concluidas = tarefas.filter(t => t.status === 'concluida').length;
        const total = tarefas.length;
        let tempoReal = 0, tempoProgramado = 0;
        if (evento.hora_inicio_real && evento.hora_fim_real) {
            const [hI, mI] = evento.hora_inicio_real.split(':').map(Number);
            const [hF, mF] = evento.hora_fim_real.split(':').map(Number);
            tempoReal = (hF * 60 + mF) - (hI * 60 + mI);
        }
        tarefas.forEach(t => tempoProgramado += t.duracao || 0);
        return { concluidas, total, tempoReal, diferenca: tempoReal - tempoProgramado };
    }, [evento]);

    return (
        <div style={{ background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px', transition: 'all 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(139,92,246,0.2)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)'; }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px', flexWrap: 'wrap' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <h3 style={{ margin: '0 0 8px', fontSize: '15px', fontWeight: 700, color: '#0f172a' }}>{evento.titulo}</h3>
                    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '8px' }}>
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '3px 8px', borderRadius: '6px', background: 'rgba(139,92,246,0.08)', border: '1px solid rgba(139,92,246,0.18)', color: '#7c3aed', fontSize: '11px' }}>
                            📅 {formatarData(evento.data)}
                        </span>
                        <span style={{ padding: '3px 8px', borderRadius: '6px', background: st.bg, border: `1px solid ${st.border}`, color: st.color, fontSize: '11px', fontWeight: 600 }}>
                            {st.label}
                        </span>
                    </div>
                    <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                        <span style={{ fontSize: '12px', color: '#64748b' }}>
                            {stats.concluidas}/{stats.total} tarefas
                        </span>
                        {evento.status === 'concluido' && stats.tempoReal > 0 && (
                            <>
                                <span style={{ fontSize: '12px', color: '#64748b' }}>
                                    {Math.floor(stats.tempoReal / 60)}h {stats.tempoReal % 60}m
                                </span>
                                {stats.diferenca !== 0 && (
                                    <span style={{ padding: '1px 7px', borderRadius: '5px', background: stats.diferenca > 0 ? 'rgba(239,68,68,0.08)' : 'rgba(44,203,144,0.08)', border: `1px solid ${stats.diferenca > 0 ? 'rgba(239,68,68,0.2)' : 'rgba(44,203,144,0.2)'}`, color: stats.diferenca > 0 ? '#ef4444' : '#2CCB90', fontSize: '11px', fontWeight: 600 }}>
                                        {stats.diferenca > 0 ? '+' : ''}{stats.diferenca} min
                                    </span>
                                )}
                            </>
                        )}
                    </div>
                    {evento.descricao && <p style={{ margin: '6px 0 0', fontSize: '12px', color: '#94a3b8', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{evento.descricao}</p>}
                </div>
                <button onClick={() => setExpanded(!expanded)}
                    style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 12px', borderRadius: '8px', background: '#f8fafc', border: '1px solid #e2e8f0', color: '#64748b', fontSize: '12px', fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', flexShrink: 0, transition: 'all 0.15s' }}>
                    {expanded ? 'Menos' : 'Mais'}
                    <span style={{ transition: 'transform 0.2s', transform: expanded ? 'rotate(180deg)' : 'none' }}><ChevronDown /></span>
                </button>
            </div>

            {expanded && (
                <div style={{ marginTop: '14px', paddingTop: '14px', borderTop: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {evento.hora_inicio_real && (
                        <div>
                            <p style={{ margin: '0 0 4px', fontSize: '11px', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Horários</p>
                            <div style={{ display: 'flex', gap: '12px', fontSize: '12px', color: '#64748b' }}>
                                <span>Início: {evento.hora_inicio_real}</span>
                                {evento.hora_fim_real && <span>Fim: {evento.hora_fim_real}</span>}
                            </div>
                        </div>
                    )}
                    {evento.tarefas?.length > 0 && (
                        <div>
                            <p style={{ margin: '0 0 8px', fontSize: '11px', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Tarefas ({evento.tarefas.length})</p>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                {evento.tarefas.slice(0, 5).map(tarefa => (
                                    <div key={tarefa.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px' }}>
                                        <span style={{ color: tarefa.status === 'concluida' ? '#2CCB90' : tarefa.status === 'em_andamento' ? '#2563eb' : '#e2e8f0', flexShrink: 0 }}>
                                            <SmCheckIcon />
                                        </span>
                                        <span style={{ flex: 1, color: '#64748b' }}>{tarefa.titulo}</span>
                                        {tarefa.responsavel && <span style={{ color: '#94a3b8' }}>• {tarefa.responsavel}</span>}
                                    </div>
                                ))}
                                {evento.tarefas.length > 5 && (
                                    <p style={{ margin: '4px 0 0', fontSize: '11px', color: '#94a3b8' }}>+ {evento.tarefas.length - 5} outras tarefas</p>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

const EventosRecentes = ({ eventos, onRefresh }) => {
    const [tabAtiva, setTabAtiva] = useState(0);

    const { eventosAtivos, eventosRecentes } = useMemo(() => ({
        eventosAtivos: eventos.filter(e => e.status === 'agendado' || e.status === 'em_andamento'),
        eventosRecentes: eventos.filter(e => e.status === 'concluido').slice(0, 10),
    }), [eventos]);

    return (
        <div style={{ background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '24px', fontFamily: "'Inter', -apple-system, sans-serif", boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
                <div>
                    <h3 style={{ margin: '0 0 2px', fontSize: '18px', fontWeight: 700, color: '#0f172a' }}>Eventos</h3>
                    <p style={{ margin: 0, fontSize: '13px', color: '#64748b' }}>Visão geral de todos os eventos</p>
                </div>
                <button onClick={onRefresh}
                    style={{ padding: '7px 16px', borderRadius: '9px', background: '#f8fafc', border: '1px solid #e2e8f0', color: '#64748b', fontSize: '13px', fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', transition: 'all 0.15s' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f0fdf8'}
                    onMouseLeave={e => e.currentTarget.style.background = '#f8fafc'}
                >
                    Atualizar
                </button>
            </div>

            <div style={{ display: 'flex', gap: '6px', marginBottom: '18px' }}>
                {[`Ativos (${eventosAtivos.length})`, `Recentes (${eventosRecentes.length})`].map((label, i) => (
                    <button key={i} onClick={() => setTabAtiva(i)}
                        style={{ padding: '7px 16px', borderRadius: '8px', fontSize: '13px', fontWeight: 600, border: '1px solid transparent', cursor: 'pointer', fontFamily: 'inherit', transition: 'all 0.15s',
                            background: tabAtiva === i ? 'rgba(44,203,144,0.1)' : '#f8fafc',
                            borderColor: tabAtiva === i ? 'rgba(44,203,144,0.25)' : '#e2e8f0',
                            color: tabAtiva === i ? '#2CCB90' : '#64748b' }}>
                        {label}
                    </button>
                ))}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {tabAtiva === 0 ? (
                    eventosAtivos.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '32px', color: '#94a3b8', fontSize: '14px' }}>Nenhum evento ativo no momento</div>
                    ) : eventosAtivos.map(e => <EventoCard key={e.id} evento={e} />)
                ) : (
                    eventosRecentes.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '32px', color: '#94a3b8', fontSize: '14px' }}>Nenhum evento concluído ainda</div>
                    ) : eventosRecentes.map(e => <EventoCard key={e.id} evento={e} />)
                )}
            </div>
        </div>
    );
};

export default EventosRecentes;
